import {
  MondayBatchJobStateJobStatus,
  MondayBatchJobStateJobType,
  TouchpointDTOBatchJobExecutionStatus,
  TouchpointDTOBatchJobType,
  type MondayBatchJobState,
} from "generated/schemas";

export const isEmailWriterJobRunning = ({
  batchJobType,
  batchJobExecutionStatus,
}: {
  batchJobType?: TouchpointDTOBatchJobType;
  batchJobExecutionStatus?: TouchpointDTOBatchJobExecutionStatus;
}): boolean =>
  batchJobType === TouchpointDTOBatchJobType.WRITING &&
  batchJobExecutionStatus === TouchpointDTOBatchJobExecutionStatus.RUNNING;

export type EmailWriterJobsOutcome = "none" | "running" | "failed" | "succeeded";

export const getEmailWriterJobsOutcome = (
  jobStates: MondayBatchJobState[],
  touchpointIds?: string[],
): EmailWriterJobsOutcome => {
  const writerJobs = jobStates.filter(
    (job) =>
      job.jobType === MondayBatchJobStateJobType.WRITING &&
      (!touchpointIds || touchpointIds.includes(job.touchpointId)),
  );

  if (writerJobs.length === 0) {
    return "none";
  }

  if (writerJobs.some((job) => job.jobStatus === MondayBatchJobStateJobStatus.RUNNING)) {
    return "running";
  }

  if (writerJobs.some((job) => job.jobStatus === MondayBatchJobStateJobStatus.FAILED)) {
    return "failed";
  }

  return "succeeded";
};
